import React, { useCallback, useMemo, useState } from 'react';
import { format } from 'date-fns';
import { StyleSheet, View } from 'react-native';
import Modal from 'utils/packages/Modal';
import { CalendarRange } from 'design-system/calendar/CalendarRange';
import { rem } from './values';
import Button from './Button';
import Spacer from './Spacer';
const CalendarRangeModalContent = ({ maxDate, minDate, onRangeChange, }) => {
    const [range, setRange] = useState([]);
    const todayDateStr = new Date().toISOString().slice(0, 10);
    const onChangeRange = useCallback((range) => {
        setRange(range);
    }, []);
    const handleSave = useCallback(() => {
        if (range.length === 2) {
            Modal.hide(() => {
                onRangeChange(range);
            });
        }
    }, [onRangeChange, range]);
    const calendarTitle = useMemo(() => {
        if (range.length) {
            let date = `${format(range[0], 'MMM d y')} - `;
            if (range[1]) {
                date += format(range[1], 'MMM d y');
            }
            return date;
        }
        return 'Any day';
    }, [range]);
    return (<View>
      <Spacer h={8}/>
      <CalendarRange fixedHeight hideDays showReset showDisabled blackMonthText maxDate={maxDate} minDate={minDate} noMarginHorizontal unrestrictedWidth title={calendarTitle} hideExtraDays={false} initialDate={todayDateStr} onChangeRange={onChangeRange} style={styles.calendarContainer}/>
      <Spacer h={16}/>
      <View style={styles.btnContainer}>
        <Button brand title="Save" onPress={handleSave} disabled={range.length !== 2}/>
      </View>
    </View>);
};
export const CalendarRangeModal = {
    show: (onRangeChange, setModalClose, maxDate, minDate) => {
        Modal.show(<CalendarRangeModalContent maxDate={maxDate} minDate={minDate} onRangeChange={onRangeChange}/>, {
            title: 'Select a range',
            containerStyle: styles.modal,
            onDidHideCallback: setModalClose,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
    },
    calendarContainer: {
        maxWidth: '100%',
    },
    btnContainer: {
        paddingHorizontal: rem(16),
    },
});
export default CalendarRangeModal;
